import { FC } from 'react';
import { Icon } from '@anyroad/icon';

import { PricingRuleItem, PricingRuleMessage } from './styles';
import { PricingRule } from './types';

interface ExperiencePricingRulesProps {
  pricingRules: Map<string, PricingRule> | null;
}

export const ExperiencePricingRules: FC<ExperiencePricingRulesProps> = ({
  pricingRules,
}) => {
  if (!pricingRules || pricingRules.size === 0) {
    return null;
  }

  const seenIds = new Set<number>();
  const seenMessages = new Set<string>();
  const uniqueRules: PricingRule[] = [];

  pricingRules.forEach((rule) => {
    if (!seenIds.has(rule.id) && !seenMessages.has(rule.message)) {
      seenIds.add(rule.id);
      seenMessages.add(rule.message);
      uniqueRules.push(rule);
    }
  });

  if (uniqueRules.length === 0) {
    return null;
  }

  return (
    <>
      {uniqueRules.map((rule) => (
        <PricingRuleItem key={rule.id}>
          <Icon name="Tag" height={16} width={16} />
          <PricingRuleMessage>{rule.message}</PricingRuleMessage>
        </PricingRuleItem>
      ))}
    </>
  );
};
